import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import QRPage from "../pages/qr/page";
import QRApplyPage from "../pages/qr-apply/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/qr",
    element: <QRPage />,
  },
  {
    path: "/qr-apply",
    element: <QRApplyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
